import RegisterForm from "../../components/RegisterForm/RegisterForm";
import RegisterFormPageStyles from "./RegisterFormPageStyles";

const RegisterFormPage = (): JSX.Element => {
  return (
    <RegisterFormPageStyles>
      <RegisterForm />
    </RegisterFormPageStyles>
  );
};

export default RegisterFormPage;
